import { motion } from "framer-motion";
import { AnimatedSvg } from "@/components";
import { COST_CHART } from "@/content";

const SVG_STYLE = {
  width: "100%",
  height: "auto",
  fontFamily: '"Founders Grotesk", "Helvetica Neue", Arial, sans-serif',
  fontWeight: 300,
} as const;

export const CostChart = () => (
  <AnimatedSvg
    viewBox="0 0 960 400"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label={COST_CHART.ariaLabel}
    style={SVG_STYLE}
  >
    <motion.g
      variants={{
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { delay: 0.08, duration: 0.2 } },
      }}
      stroke="#cccac8"
      strokeWidth="1"
      fill="none"
    >
      <motion.path
        d="M100 50 V320"
        variants={{ hidden: { pathLength: 0 }, visible: { pathLength: 1, transition: { duration: 0.45 } } }}
      />
      <motion.path
        d="M100 320 H845"
        variants={{ hidden: { pathLength: 0 }, visible: { pathLength: 1, transition: { delay: 0.1, duration: 0.65 } } }}
      />
      <motion.path
        d="M100 320 v6 M223 320 v6 M347 320 v6 M470 320 v6 M594 320 v6 M717 320 v6 M840 320 v6"
        variants={{
          hidden: { pathLength: 0 },
          visible: { pathLength: 1, transition: { delay: 0.26, duration: 0.45 } },
        }}
      />
    </motion.g>

    <motion.g
      variants={{
        hidden: { opacity: 0, y: 5 },
        visible: { opacity: 1, y: 0, transition: { delay: 0.35, duration: 0.35 } },
      }}
      fill="#6e6e6b"
      fontSize="11"
      textAnchor="middle"
    >
      <text x="100" y="341">
        0
      </text>
      <text x="223" y="341">
        2
      </text>
      <text x="347" y="341">
        4
      </text>
      <text x="470" y="341">
        6
      </text>
      <text x="594" y="341">
        8
      </text>
      <text x="717" y="341">
        10
      </text>
      <text x="840" y="341">
        12
      </text>
    </motion.g>

    <motion.g
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 0.45, duration: 0.35 } } }}
      fill="#6e6e6b"
      fontSize="12"
      letterSpacing="1.4"
    >
      <text x="470" y="370" textAnchor="middle">
        MONTHS
      </text>
      <text x="52" y="185" transform="rotate(-90 52 185)" textAnchor="middle">
        CUMULATIVE COST
      </text>
    </motion.g>

    <motion.path
      d="M100 320 H162 V290 H223 V268 H347 V214 H408 V196 H532 V162 H655 V104 H779 V70 H840"
      fill="none"
      stroke="#6e6e6b"
      strokeWidth="2"
      strokeLinejoin="round"
      strokeLinecap="round"
      variants={{
        hidden: { pathLength: 0, opacity: 0 },
        visible: { pathLength: 1, opacity: 1, transition: { delay: 0.78, duration: 1.1, ease: "easeInOut" } },
      }}
    />

    <motion.path
      d="M100 320 L840 170"
      fill="none"
      stroke="#be4720"
      strokeWidth="2"
      strokeLinecap="round"
      variants={{
        hidden: { pathLength: 0, opacity: 0 },
        visible: { pathLength: 1, opacity: 1, transition: { delay: 0.55, duration: 0.72, ease: "easeOut" } },
      }}
    />

    <motion.g
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 1.25, duration: 0.4 } } }}
      fill="#6e6e6b"
      fontSize="11"
    >
      <text x="169" y="283">
        Designers
      </text>
      <text x="230" y="261">
        Programmers
      </text>
      <text x="402" y="207" textAnchor="end">
        Yarn + MOQ
      </text>
      <text x="415" y="189">
        Shipping
      </text>
      <text x="539" y="155">
        Development time
      </text>
      <text x="662" y="97">
        Re-sample
      </text>
      <text x="833" y="63" textAnchor="end">
        Factory time
      </text>
    </motion.g>

    <motion.text
      x="566"
      y="256"
      fill="#6e6e6b"
      fontSize="11"
      textAnchor="middle"
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 1.02, duration: 0.35 } } }}
    >
      same amount every month
    </motion.text>

    <motion.circle
      cx="840"
      cy="70"
      r="4.5"
      fill="#6e6e6b"
      stroke="#f5f3f0"
      strokeWidth="2"
      variants={{
        hidden: { opacity: 0, scale: 0 },
        visible: { opacity: 1, scale: 1, transition: { delay: 1.78, type: "spring", stiffness: 360, damping: 18 } },
      }}
    />
    <motion.circle
      cx="840"
      cy="170"
      r="4.5"
      fill="#be4720"
      stroke="#f5f3f0"
      strokeWidth="2"
      variants={{
        hidden: { opacity: 0, scale: 0 },
        visible: { opacity: 1, scale: 1, transition: { delay: 1.28, type: "spring", stiffness: 360, damping: 18 } },
      }}
    />

    <motion.g
      variants={{
        hidden: { opacity: 0, x: -7 },
        visible: { opacity: 1, x: 0, transition: { delay: 1.86, duration: 0.35 } },
      }}
      fill="#1a1919"
      fontSize="14"
    >
      <text x="853" y="74">
        Traditional
      </text>
      <text x="853" y="174">
        LOOP
      </text>
    </motion.g>
  </AnimatedSvg>
);
